<div class="container-fluid p-3">
  <div class="page-header mb-4">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h4 class="mb-1">AIP</h4>
        <h5 class="text-primary">[{{ payload?.proposal_name }}]</h5>
        <div class="status-badge">
          <span class="badge" [ngClass]="{
              'bg-secondary': stepDetails?.step_status == 0,
              'bg-success': stepDetails?.step_status == 'approved',
              'bg-warning': stepDetails?.step_status == 'recommended',
              'bg-info': stepDetails?.step_status == 'initiated'
            }">
            {{
            stepDetails?.step_status == 0
            ? "INITIATION PENDING"
            : (stepDetails?.step_status | uppercase)
            }}
          </span>
        </div>
      </div>

      <div class="action-buttons">
        <!-- <button class="btn btn-blue me-2" (click)="generatePDF()">
          <i class="pi pi-file-pdf me-1"></i> PDF
        </button> -->

        <ng-container *ngIf="stepDetails?.step_status == 'approved'">
          <button class="btn btn-outline-primary me-2" (click)="goToNextStep()">
            Next <i class="pi pi-angle-right ms-1"></i>
          </button>
        </ng-container>

        <ng-container *ngIf="stepDetails?.can_edit || (stepDetails?.step_status != 'approved' && userID == 6)">
          <button (click)="routeConfig.emit({isRouteConfig: true})" 
                  [disabled]="(schemeType === 'tdf' && proposalForm?.invalid) || (schemeType !== 'tdf' && challengeForm?.invalid)"
                  class="inline-flex items-center px-4 py-2.5 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:bg-slate-300 disabled:cursor-not-allowed transition-all duration-200 font-medium text-sm shadow-sm hover:shadow-md">
            <i class="pi pi-save mr-2"></i> Save/Forward/Route Config
          </button>
        </ng-container>
        
        
      </div>
    </div>
  </div>
  <hr class="my-3" />
  <!-- <app-upload-document [isEditable]="stepDetails?.can_edit" [id]="id"></app-upload-document> -->
  <app-upload-document [isEditable]="stepDetails?.can_edit" [title]="lable"></app-upload-document>
  

   <div class="row mt-4">
    <div class="col-4 bg-primary text-white d-flex align-items-center">
      <b class="fw-semibold mb-0 text-white">Remarks  </b>
    </div>
    <div class="col-8">
      <textarea id="remarks" class="form-control" [(ngModel)]="remark" rows="4" placeholder="Enter any remarks..." [disabled]="isEditorDisabled"></textarea>
    </div>
  </div>

  <!-- <form [formGroup]="aip">
    <div class="row mb-3">
      <div class="col-md-6">
        <label for="file_name">File Name <b class="text-danger">*</b></label>
        <input pInputText id="file_name" pSize="large" formControlName="file_name" autocomplete="off" class="w-100" />
      </div>

      <div class="col-md-6">
        <label for="file_number">File Number <b class="text-danger">*</b></label>
        <input pInputText id="file_number" pSize="large" formControlName="file_number" autocomplete="off"
          class="w-100" />
      </div>
    </div>

     <div class="upload-section mt-3">
      <label
        class="mb-2"
        *ngIf="
          stepDetails?.is_initiator || 
          stepDetails?.is_approver ||
          stepDetails?.is_recommender || stepDetails.can_edit ||
          (stepDetails?.step_status != 'approved' && userID == 6)
        ">
        Upload Signed Document
      </label>
      <p-fileUpload name="demo[]" #fileUpload [auto]="true" [customUpload]="true" (onSelect)="onUpload($event)"
        [showUploadButton]="false" [multiple]="false" mode="advanced" [accept]="'.pdf,.docx,.csv,.jpeg,.jpg,.png'"
        [maxFileSize]="209715200" *ngIf="
          stepDetails?.is_initiator ||
          stepDetails?.is_approver ||
          stepDetails?.is_recommender || stepDetails.can_edit ||
          (stepDetails?.step_status != 'approved' && userID == 6)
        ">
      </p-fileUpload>
      <div class="d-flex justify-content-end mt-2 mb-2">
        <button pButton type="button" label="Upload File" class="fetch-data-btn" (click)="onSubmit()" [disabled]="
            aip.invalid ||
            !(
              stepDetails?.is_initiator ||
              stepDetails?.is_approver ||
              stepDetails?.is_recommender || stepDetails.can_edit ||
              (stepDetails?.step_status != 'approved' && userID == 6)
            )
          "></button>
      </div>
      <div *ngIf="uploadedFiles" class="mt-2">
        <label>Previously Uploaded:</label>
        <a [href]="apiUrl + uploadedFiles" target="_blank">
          {{ getFileName(uploadedFiles) }}
        </a>
      </div>
    </div>
    <hr />

    <div class="card mb-5 p-4 mt-4">
      <div class="table-responsive">
        <table class="custom-table">
          <thead>
            <tr>
              <th class="wid-4rem"></th>
              <th>File Name</th>
              <th>File Number</th>
              <th>PDF Name</th>
              <th>Status</th>
              <th>Document</th>
              <th *ngIf="
                  stepDetails?.is_initiator ||
                  stepDetails?.is_approver ||
                  stepDetails?.is_recommender || stepDetails.can_edit ||
                  (stepDetails?.step_status != 'approved' && userID == 6)
                ">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let product of aipData" [class.selected]="selectedProduct?.code === product.code">
              <td>
                <input type="radio" name="productSelection" [checked]="selectedProduct?.code === product.code"
                  (change)="selectedProduct = product" />
              </td>
              <td>{{ product.file_name }}</td>
              <td>{{ product.file_number }}</td>
              <td>{{ getFileName(product.document) }}</td>
              <td>
                <span class="status-tag" [class.info]="product.file_status === 1"
                  [class.success]="product.file_status !== 1">
                  {{ product.file_status === 1 ? "Under Review" : "Finalized" }}
                </span>
              </td>
              <td>
                <a [href]="apiUrl + product.document" target="_blank">View</a>
              </td>
              <td *ngIf="
                  stepDetails?.is_initiator ||
                  stepDetails?.is_approver ||
                  stepDetails?.is_recommender || stepDetails.can_edit ||
                  (stepDetails?.step_status != 'approved' && userID == 6)
                ">
                <button type="button" (click)="edit(product)" class="btn btn-primary">
                  Edit
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div> 

    <div class="d-flex justify-content-end mt-3 mb-3">
      <button type="button" class="btn btn-primary" (click)="finalize()" [disabled]="!isEditable || !selectedProduct">
        Finalize
      </button>
    </div>
  </form> -->
</div>